module.exports = __webpack_public_path__ + "img/aeroland-tab-content-image-01.293afe58.jpg";